import { v4 as uuidv4 } from "uuid";

const api = async ({ url, method = "GET", headers, payload }) => {
  try {
    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": sessionStorage.getItem("sessionToken"),
        "X-Transaction-Id": uuidv4(),
        ...headers,
      },
      body: method === "GET" ? null : JSON.stringify(payload),
    });
    if (response.status === 200) {
      try {
        const reponseJson = await response.json();
        if (reponseJson.error) {
          if (
            reponseJson.error_description ===
            "Invalid token type in Authorization header."
          ) {
            alert("Invalid Token, Please login first");
          } else if (reponseJson.error === "unauthorized_client") {
            alert(
              "This user is not authorized to fetch device list, please log in as device user"
            );
          } else if (reponseJson.error === "bad_request") {
            alert("Bad request");
          }
          return new Error(reponseJson);
        }
        return reponseJson;
      } catch (e) {
        return response;
      }
    } else {
      const reponseJson = await response.json();
      throw new Error(reponseJson.error_description);
    }
  } catch (error) {
    console.log("Error", error);
    throw new Error(error);
  }
};

export default api;
